/// <reference types="@angular/localize" />

import { platformBrowser } from '@angular/platform-browser';
import * as DevExpressAnalytics from 'devexpress-reporting';
import { AppModule } from './app/app-module';
import { licenseKey } from './devextreme-license';
import config from 'devextreme/core/config';
import { User } from './app/Api/DcoApi/Client/RestClient';
import { openobserveRum } from '@openobserve/browser-rum';
import { openobserveLogs } from '@openobserve/browser-logs';



if(window.location.hostname !== 'gkv.local') {
// OpenObserve RUM initialisieren
  openobserveRum.init({
    applicationId: 'WebUI',
    clientToken: 'rumxSV8sxIS1o7KyMJ6', // Aus OpenObserve UI: Ingestion -> RUM
    site: 'metrics.dco-care.de', // Oder http://localhost:5080
    organizationIdentifier: 'default',
    service: 'angular-frontend',
    env: 'production',
    version: '1.0.0',
    trackResources: true,           // Erfasst Ladezeiten von Assets/XHR
    trackLongTasks: true,           // Erfasst Performanz-Engpässe im Main-Thread
    trackUserInteractions: true,    // Erfasst Clicks und Formulardaten
    defaultPrivacyLevel: 'mask-user-input',
    insecureHTTP: false             // Auf true setzen, wenn lokal über http:// gearbeitet wird
  });

// Logs & uncaught Errors initialisieren
  openobserveLogs.init({
    clientToken: 'rumxSV8sxIS1o7KyMJ6',
    site: 'metrics.dco-care.de',
    organizationIdentifier: 'default',
    service: 'angular-frontend',
    env: 'production',
    version: '1.0.0',
    forwardErrorsToLogs: true,
    insecureHTTP: false
  });

// Session Replay optional starten
  openobserveRum.startSessionReplayRecording();
}

config({ licenseKey });



platformBrowser()
  .bootstrapModule(AppModule, {})
  .catch((err) => console.error(err));
